import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.outcomes',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_1',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_2',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_3',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_4',
    'resource:data.dimensions.outcomes.entities.goal.records.gmu._1_1_5',
    'resource:data.dimensions.filesPlayground',
    'resource:data.dimensions.filesPlayground.entities.filesDemo',
    'resource:data.dimensions.filesPlayground.entities.filesDemo.attributes.label',
    'resource:data.dimensions.filesPlayground.entities.filesDemo.attributes.documents',
    'resource:data.dimensions.filesPlayground.entities.filesDemo.records.sample1',
    'resource:data.dimensions.filesPlayground.entities.filesDemo.records.sample2',
    'resource:solutions.agents.naming',
    'resource:solutions.apps.playground.pages.overview',
    'resource:solutions.apps.playground',
    'resource:solutions.mosaic.actions.playground.touchAndOpenAssistant',
    'resource:solutions.mosaic.pages.playground.overview',
    'resource:solutions.mosaic.widgets.playground.goalsTable',
    'resource:solutions.mosaic.widgets.playground.openAssistantMetric',
  ],
  description:
    'Demonstrates opening the assistant slideout both via a row-click-driven ' +
    'action that also executes a real backend DMS mutation, and via a ' +
    'direct/fixed action',
  name: 'Playground',
} as const satisfies core.quiver.Package
